module.exports = __webpack_public_path__ + "assets/img/ecg-putong-icon.69e68247.png";